import styled, { css } from 'styled-components';

// update
export const BaseErrorWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: 1800px;
  min-width: 285px;
  width: 100%;
  background: transparent;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin: 40px 0 48px 0;
  }
`;
export const LeftErrorWrapper = styled.div`
  ${BaseErrorWrapper}
  height: 50vh;
  margin: 24px 0 40px 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    height: auto;
  }
`;
export const UpdateErrorWrapper = styled.div`
  ${BaseErrorWrapper}
  height: 100%;
  margin: 20px 0 90px 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    height: 100vh;
  }
`;
export const OvpErrorWrapper = styled.div`
  ${BaseErrorWrapper}
  height: 100%;
  padding: 60px 0 240px 0;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    height: 100vh;
  }
`;
export const ErrorCaption = styled.div`
  width: 290px;
  height: 48px;
  margin-top: 24px;
  color: ${(props) => props.theme.color.primary.v600};
  font-family: 'Brandon Text';
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'cpsp' on, 'liga' off;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: auto;
    height: auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 290px;
    height: 48px;
  }
`;
export const OvpErrorCaption = styled(ErrorCaption)`
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 360px;
    height: auto;
  }
`;
export const BaseErrorText = css`
  width: 280px;
  height: 48px;
  margin: 16px 0;
  color: #6d7184;
  font-family: 'Brandon Text';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 330px;
  }
`;
export const LeftErrorText = styled.div`
  ${BaseErrorText}
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 290px;
  }
`;
export const UpdateErrorText = styled.div`
  ${BaseErrorText}
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 389px;
  }
`;
export const OvpErrorText = styled.div`
  ${BaseErrorText}
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 389px;
  }
`;
export const ErrorTextTwo = styled.div<{ screen?: string }>`
  max-width: 330px;
  min-width: 245px;
  height: 48px;
  width: 100%;
  margin-bottom: 16px;
  color: #6d7184;
  font-family: 'Brandon Text';
  font-weight: 400;
  font-style: nrmal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    max-width: 360px;
  }
`;
export const PhoneNumber = styled.span`
  font-weight: bold;
  white-space: nowrap;
`;
export const NoWrap = styled.span`
  white-space: nowrap;
`;
